// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    grantId: z.string().min(1).max(128),
    userId: z.string().min(1).max(128),
    organizationId: z.string().min(1).max(21),
    clientId: z.string().min(1).max(2048),
    resource: z.string().min(1).max(2048),
    createdAt: z.number().optional(),
    expiresAt: z.number(),
    revokedAt: z.number().nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    grantId: z.string().min(1).max(128),
    userId: z.string().min(1).max(128),
    organizationId: z.string().min(1).max(21),
    clientId: z.string().min(1).max(2048),
    resource: z.string().min(1).max(2048),
    createdAt: z.number(),
    expiresAt: z.number(),
    revokedAt: z.number().nullable(),
});
export const McpResourceGrants = Object.freeze({
    table: 'mcp_resource_grants',
    tableSingular: 'mcp_resource_grant',
    fields: {
        tenantId: 'tenant_id',
        grantId: 'grant_id',
        userId: 'user_id',
        organizationId: 'organization_id',
        clientId: 'client_id',
        resource: 'resource',
        createdAt: 'created_at',
        expiresAt: 'expires_at',
        revokedAt: 'revoked_at',
    },
    fieldKeys: [
        'tenantId',
        'grantId',
        'userId',
        'organizationId',
        'clientId',
        'resource',
        'createdAt',
        'expiresAt',
        'revokedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
